<template>
  <div>
    <v-dialog v-model="dialog" width="350" :fullscreen="x_mobile">
      <v-card class="pb-2">
        <v-form ref="form" @submit.prevent="changePassword">
          <v-card-title class="form-dialog-title" primary-title>
            เปลี่ยนรหัสผ่าน
            <v-spacer></v-spacer>
            <v-btn icon class="float-right" @click="close">
              <v-icon>mdi-window-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="py-0">
            <v-row align="center" justify="center" class="px-3">
              <v-col cols="12" class="py-1 change_password_text_label">
                <v-text-field
                  prepend-inner-icon="mdi-key"
                  dense
                  class
                  v-model="password"
                  label="รหัสผ่านเดิม *"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  :rules="passwordRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="py-1 change_password_text_label">
                <v-text-field
                  prepend-inner-icon="mdi-key"
                  dense
                  v-model="new_password"
                  label="รหัสผ่านใหม่ *"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show2 ? 'text' : 'password'"
                  @click:append="show2 = !show2"
                  :rules="newpasswordRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="py-1 change_password_text_label">
                <v-text-field
                  prepend-inner-icon="mdi-key"
                  dense
                  v-model="confirm_password"
                  label="ยืนยันรหัสผ่าน *"
                  :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show3 ? 'text' : 'password'"
                  @click:append="show3 = !show3"
                  :rules="cfpasswordRules"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-6">
            <v-spacer></v-spacer>
            <v-btn color="button" dark type="submit" small>ยืนยัน</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      header_token: { headers: { token: this.$session.get("token") } },
      dialog: false,
      profile: {},
      show1: false,
      show2: false,
      show3: false,
      password: "",
      new_password: "",
      confirm_password: "",
      passwordRules: [
        (v) => !!v || "กรุณากรอกรหัสผ่าน",
        // (v) =>
        //   /^((?=.*[a-zA-Z])(?=.*[0-9]).{8,})+$/.test(v) ||
        //   "รหัสผ่านต้องมีตัวเลขและตัวอักษรภาษาอังกฤษ",
        (v) =>
          !/([ก-๏ ])/.test(v) ||
          "ต้องเป็นภาษาอังกฤษ ตัวเลขและอักขระพิเศษเท่านั้น",
        (v) => (!!v ? v.length >= 8 : false) || "ต้องความยาวอย่างน้อย 8 ตัว",
        (v) => (!!v ? v.length < 20 : false) || "ต้องความยาวไม่เกิน 20 ตัว",
      ],
      newpasswordRules: [
        (v) => !!v || "กรุณากรอกรหัสผ่าน",
        // (v) =>
        //   /^((?=.*[a-zA-Z])(?=.*[0-9]).{8,})+$/.test(v) ||
        //   "รหัสผ่านต้องมีตัวเลขและตัวอักษรภาษาอังกฤษ",
        (v) =>
          !/([ก-๏ ])/.test(v) ||
          "ต้องเป็นภาษาอังกฤษ ตัวเลขและอักขระพิเศษเท่านั้น",
        (v) => (!!v ? v.length >= 8 : false) || "ต้องความยาวอย่างน้อย 8 ตัว",
        (v) => (!!v ? v.length < 20 : false) || "ต้องความยาวไม่เกิน 20 ตัว",
        (v) => v != this.password || "รหัสผ่านต้องไม่เหมือนเดิม",
      ],

      cfpasswordRules: [
        (v) => !!v || "กรุณายืนยันรหัสผ่าน",
        (v) => v == this.new_password || "รหัสผ่านไม่ตรงกัน",
      ],
    };
  },
  computed: {
    x_mobile() {
      if (this.$vuetify.breakpoint.width < 375) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    openDialogChangePassword() {
      // console.log(this.$session.getAll());
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 50);
      this.show1 = false;
      this.show2 = false;
      this.show3 = false;
      this.password = "";
      this.new_password = "";
      this.confirm_password = "";
      this.dialog = true;
    },
    changePassword() {
      if (
        this.$refs.form.validate() &&
        this.password != this.confirm_password
      ) {
        this.profile = this.$session.get("profile");
        // console.log(this.profile);
        let data = {
          staff_id: this.profile.staff_id,
          old_password: this.password,
          new_password: this.confirm_password,
        };
        this.axios
          .post(
            process.env.VUE_APP_API + "/api/v1/change_password",
            data,
            this.header_token
          )
          .then((response) => {
            // console.log(response.data.result);
            if (
              response.data.status == "OK" &&
              response.data.status != "FAIL"
            ) {
              this.$swal.fire({
                icon: "success",
                width: 500,
                title: response.data.message,
                text: "ดำเนินการเปลี่ยนรหัสผ่านใหม่เรียบร้อยแล้ว",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
              this.close();
            } else if (response.data.status == "FAIL") {
              this.$swal.fire({
                icon: "error",
                width: 500,
                title: response.data.message,
                text: " กรุณาตรวจสอบข้อมูลของท่านอีกครั้ง",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
            }
          })
          .catch((err) => {
            this.$swal.fire({
              icon: "error",
              width: 500,
              title: "เกิดข้อผิดพลาด",
              showConfirmButton: false,
              timer: 2000,
              showCloseButton: true,
            });
          });
      }
      // else {
      //   this.$swal.fire(
      //     "กรุณากรอกรหัสผ่านใหม่",
      //     "รหัสทั้งสองช่องไม่ตรงกัน",
      //     "warning"
      //   );
      // }
    },
    close() {
      this.show1 = false;
      this.show2 = false;
      this.show3 = false;
      this.password = "";
      this.new_password = "";
      this.confirm_password = "";
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 50);
      this.dialog = false;
    },
  },
};
</script>
